// Widget chrome copy, one catalog per language. English is the source; every
// other catalog must name the same keys (the type below enforces it). Copy
// that an organization configures in Studio (branding, surface titles, CTA
// labels) does not belong here.
//
// `{name}` marks an interpolated value. A key ending `.one`/`.other` is a
// plural pair, chosen with Intl.PluralRules (`tCount`).
const en = {
  'common.unknownError': 'Unknown error',
  'common.close': 'Close',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.unknownCreator': 'Unknown',
  'common.selection': 'Selection',

  'feed.loading': 'Loading feed...',
  'feed.error': 'Error loading feed: {detail}',
  'feed.retry': 'Try Again',
  'feed.newPosts': 'New posts',
  'feed.empty': 'No posts available',
  'feed.emptyHint': 'Check back later for new content',
  'feed.loadingMore': 'Loading more...',
  'feed.end': "You're all caught up!",

  'surface.loading': 'Loading…',
  'surface.loadingMore': 'Loading more…',
  'surface.empty': 'No posts available',
  'surface.errorCarousel': 'Error loading carousel: {detail}',
  'surface.errorStories': 'Error loading stories: {detail}',
  'surface.errorGrid': 'Error loading grid: {detail}',
  'surface.errorHero': 'Error loading hero feed: {detail}',
  'surface.errorPlayer': 'Error loading player: {detail}',
  'surface.errorDeck': 'Error loading deck: {detail}',
  'surface.noStories': 'No stories available',
  'surface.seeMore': 'See more',
  'surface.openSportsFeed': 'Open sports feed',
  'surface.openFullSportsFeed': 'Open full sports feed',
  'surface.goToSeeMore': 'Go to See more',
  'surface.goToCard': 'Go to card {number}',
  'surface.featurePost': 'Feature post {number}',
  'surface.previousPost': 'Previous post',
  'surface.nextPost': 'Next post',
  'surface.heroNavigation': 'Hero navigation',
  'surface.post': 'Post {number}',
  'surface.verticalStories': 'Vertical stories',
  'surface.story': 'Story',
  'surface.openStoryFrom': 'Open story from {name}',
  'surface.storiesViewer': 'Stories viewer',
  'surface.closeStoryViewer': 'Close story viewer',
  'surface.previousStory': 'Previous story',
  'surface.nextStory': 'Next story',
  'surface.floatingPlayer': 'Floating player',
  'surface.dismissFloatingPlayer': 'Dismiss floating player',
  'surface.collapseFloatingPlayer': 'Collapse floating player',
  'surface.expandFloatingPlayer': 'Expand floating player',
  'surface.banner': 'Banner',

  'card.follow': 'Follow',
  'card.following': 'Following',
  'card.promoted': 'Promoted',
  'card.shared': 'Shared',
  'card.share': 'Share',
  'card.shareCopied': 'Copied',
  'card.shareFailed': 'Copy failed',
  'card.shareLinkCopied': 'Share link copied',
  'card.copyShareLink': 'Copy share link',
  'card.copyCount.one': 'copied',
  'card.copyCount.other': 'copied',
  'card.officialAccount': 'Official account',
  'card.moreLegs.one': '+{count} more legs',
  'card.moreLegs.other': '+{count} more legs',
  'ticket.winner': 'WINNER',

  'bet.addToBetslip': 'Add to Betslip',
  'bet.someUnavailable': 'Some selections are currently unavailable',
  'bet.someExpired': 'Some selections have expired',
  'bet.priceExpiredRefresh': 'This price has expired. Refresh before adding it.',
  'bet.suspended': 'SUSPENDED',
  'bet.closed': 'CLOSED',
  'bet.added': 'ADDED',
  'bet.expired': 'EXPIRED',
  'bet.estimated': 'Estimated',
  'bet.expiredBadge': 'Expired',
  'bet.priceExpired': 'Price expired',
  'bet.single': 'single',
  'bet.parlay': 'parlay',
  'bet.systemBet': 'system bet',
  'bet.singles': '{count} singles',
  'bet.parlays': '{count} parlays',
  'bet.typedBets': '{count} {label} bets',
  'bet.wagers': '{count} wagers',

  'leg.suspended': 'SUSPENDED',
  'leg.closed': 'CLOSED',
  'leg.won': 'WON',
  'leg.lost': 'LOST',
  'leg.live': 'LIVE',
  'leg.liveStatsDelayed': 'Live stats delayed',
  'leg.liveProgress': '{value} of {line} {unit}',
  'leg.grouped': 'Grouped selections',
  'leg.sameGameParlay': 'Same game parlay',
  'leg.sameGameParlayBadge': 'SGP',
  'leg.viewDetails': 'View leg details',
  'leg.count.one': '{count} leg',
  'leg.count.other': '{count} legs',
  'leg.selectionCount.one': '{count} selection',
  'leg.selectionCount.other': '{count} selections',
  'leg.viewAll.one': 'View all {count} leg',
  'leg.viewAll.other': 'View all {count} legs',
  'leg.details.one': '{count} leg details',
  'leg.details.other': '{count} legs details',

  'parlay.suggested': 'Suggested parlay',
  'parlay.promotedSpecial': 'Promoted special',
  'parlay.editorial': 'Editorial',
  'parlay.why': 'Why this parlay',
  'parlay.typeParlay': 'Parlay',
  'parlay.typeSgp': 'SGP',
  'parlay.typeSgpPlus': 'SGP+',
  'parlay.legCount': '{count}-leg parlay',
  'parlay.typedLegCount': '{count}-leg {type}',
  'parlay.viewAllLegs': 'View all legs ({count})',
  'parlay.allLegs': 'All {count} parlay legs',
  'parlay.closeAllLegs': 'Close all legs',
  'parlay.add': 'Add parlay to betslip',
  'parlay.addAt': 'Add parlay at {odds}',
  'parlay.estimatedPrice': 'estimated price',
  'parlay.pays': '{stake} pays {payout}',
  'parlay.placedThisBet.one': 'people placed this bet',
  'parlay.placedThisBet.other': 'people placed this bet',
  'parlay.betsPlaced.one': 'bets placed',
  'parlay.betsPlaced.other': 'bets placed',

  'editorial.onePick': 'One pick, ready to play',
  'editorial.sameGame': 'Same-game power play',
  'editorial.multiPick': '{count}-pick power play',
  'editorial.pickedForYou': 'Picked for you',
  'editorial.personalizedBet': 'Personalized bet',
  'editorial.more': '{visible} + {remaining} more',

  'media.play': 'Play',
  'media.pause': 'Pause',
  'media.mute': 'Mute',
  'media.unmute': 'Unmute',
  'media.captions': 'Captions',
  'media.back': 'Back {seconds} seconds',
  'media.forward': 'Forward {seconds} seconds',
  'media.seek': 'Seek',
  'media.position': '{current} of {duration}',
  'media.playbackSpeed': 'Playback speed',
  'media.playbackSpeedValue': 'Playback speed, {rate}',
} as const

export type MessageKey = keyof typeof en
export type Catalog = Readonly<Record<MessageKey, string>>

// Latin American Spanish (es-419). Betting terms follow the Kambi client the
// widget sits in on RushBet: "cupón" for the betslip, "Parlay del partido"
// (PDP) for a same game parlay, "en vivo".
const es: Catalog = {
  'common.unknownError': 'Error desconocido',
  'common.close': 'Cerrar',
  'common.previous': 'Anterior',
  'common.next': 'Siguiente',
  'common.unknownCreator': 'Desconocido',
  'common.selection': 'Selección',

  'feed.loading': 'Cargando publicaciones...',
  'feed.error': 'No pudimos cargar las publicaciones.',
  'feed.retry': 'Reintentar',
  'feed.newPosts': 'Nuevas publicaciones',
  'feed.empty': 'No hay publicaciones disponibles',
  'feed.emptyHint': 'Vuelve más tarde para ver contenido nuevo',
  'feed.loadingMore': 'Cargando más...',
  'feed.end': '¡Estás al día!',

  'surface.loading': 'Cargando…',
  'surface.loadingMore': 'Cargando más…',
  'surface.empty': 'No hay publicaciones disponibles',
  'surface.errorCarousel': 'No pudimos cargar el carrusel.',
  'surface.errorStories': 'No pudimos cargar las historias.',
  'surface.errorGrid': 'No pudimos cargar las publicaciones.',
  'surface.errorHero': 'No pudimos cargar las publicaciones.',
  'surface.errorPlayer': 'No pudimos cargar el reproductor.',
  'surface.errorDeck': 'No pudimos cargar las publicaciones.',
  'surface.noStories': 'No hay historias disponibles',
  'surface.seeMore': 'Ver más',
  'surface.openSportsFeed': 'Abrir el feed deportivo',
  'surface.openFullSportsFeed': 'Abrir el feed deportivo completo',
  'surface.goToSeeMore': 'Ir a Ver más',
  'surface.goToCard': 'Ir a la tarjeta {number}',
  'surface.featurePost': 'Publicación destacada {number}',
  'surface.previousPost': 'Publicación anterior',
  'surface.nextPost': 'Publicación siguiente',
  'surface.heroNavigation': 'Navegación de publicaciones',
  'surface.post': 'Publicación {number}',
  'surface.verticalStories': 'Historias verticales',
  'surface.story': 'Historia',
  'surface.openStoryFrom': 'Abrir la historia de {name}',
  'surface.storiesViewer': 'Visor de historias',
  'surface.closeStoryViewer': 'Cerrar el visor de historias',
  'surface.previousStory': 'Historia anterior',
  'surface.nextStory': 'Historia siguiente',
  'surface.floatingPlayer': 'Reproductor flotante',
  'surface.dismissFloatingPlayer': 'Cerrar el reproductor flotante',
  'surface.collapseFloatingPlayer': 'Contraer el reproductor flotante',
  'surface.expandFloatingPlayer': 'Expandir el reproductor flotante',
  'surface.banner': 'Banner',

  'card.follow': 'Seguir',
  'card.following': 'Siguiendo',
  'card.promoted': 'Promocionado',
  'card.shared': 'Compartido',
  'card.share': 'Compartir',
  'card.shareCopied': 'Copiado',
  'card.shareFailed': 'No se pudo copiar',
  'card.shareLinkCopied': 'Enlace copiado',
  'card.copyShareLink': 'Copiar el enlace para compartir',
  'card.copyCount.one': 'copia',
  'card.copyCount.other': 'copias',
  'card.officialAccount': 'Cuenta oficial',
  'card.moreLegs.one': '+{count} selección más',
  'card.moreLegs.other': '+{count} selecciones más',
  'ticket.winner': 'GANADOR',

  'bet.addToBetslip': 'Añadir al cupón',
  'bet.someUnavailable': 'Algunas selecciones no están disponibles en este momento',
  'bet.someExpired': 'Algunas selecciones vencieron',
  'bet.priceExpiredRefresh': 'Esta cuota venció. Actualiza antes de añadirla.',
  'bet.suspended': 'SUSPENDIDA',
  'bet.closed': 'CERRADA',
  'bet.added': 'AÑADIDA',
  'bet.expired': 'VENCIDA',
  'bet.estimated': 'Estimada',
  'bet.expiredBadge': 'Vencida',
  'bet.priceExpired': 'Cuota vencida',
  'bet.single': 'sencilla',
  'bet.parlay': 'parlay',
  'bet.systemBet': 'apuesta de sistema',
  'bet.singles': '{count} sencillas',
  'bet.parlays': '{count} parlays',
  'bet.typedBets': '{count} apuestas {label}',
  'bet.wagers': '{count} apuestas',

  'leg.suspended': 'SUSPENDIDA',
  'leg.closed': 'CERRADA',
  'leg.won': 'GANADA',
  'leg.lost': 'PERDIDA',
  'leg.live': 'EN VIVO',
  'leg.liveStatsDelayed': 'Estadísticas en vivo demoradas',
  'leg.liveProgress': '{value} de {line} {unit}',
  'leg.grouped': 'Selecciones agrupadas',
  'leg.sameGameParlay': 'Parlay del partido',
  'leg.sameGameParlayBadge': 'PDP',
  'leg.viewDetails': 'Ver el detalle de la selección',
  'leg.count.one': '{count} selección',
  'leg.count.other': '{count} selecciones',
  'leg.selectionCount.one': '{count} selección',
  'leg.selectionCount.other': '{count} selecciones',
  'leg.viewAll.one': 'Ver {count} selección',
  'leg.viewAll.other': 'Ver las {count} selecciones',
  'leg.details.one': 'Detalle de {count} selección',
  'leg.details.other': 'Detalle de {count} selecciones',

  'parlay.suggested': 'Parlay sugerido',
  'parlay.promotedSpecial': 'Especial promocionado',
  'parlay.editorial': 'Editorial',
  'parlay.why': '¿Por qué este parlay?',
  'parlay.typeParlay': 'Parlay',
  'parlay.typeSgp': 'PDP',
  'parlay.typeSgpPlus': 'PDP+',
  'parlay.legCount': 'Parlay de {count} selecciones',
  'parlay.typedLegCount': '{type} de {count} selecciones',
  'parlay.viewAllLegs': 'Ver todas las selecciones ({count})',
  'parlay.allLegs': 'Las {count} selecciones del parlay',
  'parlay.closeAllLegs': 'Cerrar las selecciones',
  'parlay.add': 'Añadir el parlay al cupón',
  'parlay.addAt': 'Añadir el parlay a {odds}',
  'parlay.estimatedPrice': 'cuota estimada',
  'parlay.pays': '{stake} paga {payout}',
  'parlay.placedThisBet.one': 'persona hizo esta apuesta',
  'parlay.placedThisBet.other': 'personas hicieron esta apuesta',
  'parlay.betsPlaced.one': 'apuesta realizada',
  'parlay.betsPlaced.other': 'apuestas realizadas',

  'editorial.onePick': 'Una selección, lista para jugar',
  'editorial.sameGame': 'Parlay del partido',
  'editorial.multiPick': 'Parlay de {count} selecciones',
  'editorial.pickedForYou': 'Elegido para ti',
  'editorial.personalizedBet': 'Apuesta personalizada',
  'editorial.more': '{visible} + {remaining} más',

  'media.play': 'Reproducir',
  'media.pause': 'Pausar',
  'media.mute': 'Silenciar',
  'media.unmute': 'Activar el sonido',
  'media.captions': 'Subtítulos',
  'media.back': 'Retroceder {seconds} segundos',
  'media.forward': 'Adelantar {seconds} segundos',
  'media.seek': 'Buscar',
  'media.position': '{current} de {duration}',
  'media.playbackSpeed': 'Velocidad de reproducción',
  'media.playbackSpeedValue': 'Velocidad de reproducción, {rate}',
}

export const CATALOGS = Object.freeze({ en, es })
export type Language = keyof typeof CATALOGS
